import { Loader, Stack } from "@mantine/core";
import { useEffect } from "react";
import { useStore } from "../store";
import { getProfile } from "../api";

const enableDebug = !!(import.meta.env.VITE_IS_DEBUG === "true");

function PricingPage() {
  const profile = useStore((state) => state.profile);
  const setProfile = useStore((state) => state.setProfile);

  useEffect(() => {
    // Mount-only bootstrap; adding `profile` would refetch on every store update.
    if (!profile || !profile.tenantId) {
      getProfile().then((data) => {
        setProfile(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setProfile]);

  if (!profile || !profile.tenantId) {
    return <Loader />;
  }

  return (
    <Stack>
      {enableDebug ? (
        <stripe-pricing-table
          pricing-table-id="prctbl_1PVhh5IlbVPMDg50mkdElngB"
          publishable-key="pk_test_51PDOriIlbVPMDg50Gijt6o3BsXywPKtm24eEjHXvRn5qULdSNDDvOo1EmyIHzqGUPh084zvKmsTHedw58jWpQ2iI00MhXJTrjS"
          client-reference-id={profile.tenantId}
        ></stripe-pricing-table>
      ) : (
        <stripe-pricing-table
          pricing-table-id="prctbl_1SJXP3IlbVPMDg505tGKKPY6"
          publishable-key="pk_live_51PDOriIlbVPMDg50xEsvZ3pn51UkISCsXHHY4Z6FOneSGb59eCTbMHMNNhy1RxfM7AwrR2fgD55C8mJG4lUGr5ZY00wqtoMkIw"
        ></stripe-pricing-table>
      )}
    </Stack>
  );
}

export default PricingPage;
